import * as actionTypes from './types';
import fetchData from '../services';

export const clearUserFormData = () => {
   return {
      type: actionTypes.CLEAR_ADD_VIEW_USER,
      payload: {},
   };
};

export const addUserFormData = (userData) => {
   return {
      type: actionTypes.ADD_VIEW_USER,
      payload: userData,
   };
};

export const editUserFormData = (userData) => {
   return {
      type: actionTypes.EDIT_VIEW_USER,
      payload: userData,
   };
};

export const userDeleteModal = (id) => {
   return {
      type: actionTypes.USER_DELETE_MODAL,
      userId: id ? id : '',
   };
};

export const companyUserLists = (skip, limit, pageNumber, search) => {
   return (dispatch) => {
      let response = fetchData({
         url: '/company/users/list',
         method: 'POST',
         data: { limit: limit, skip: skip, search: search, companyId: sessionStorage.getItem('userId') },
      });
      //dispatch({type: actionTypes.SET_TABLE_ATTRIBUTES, page_no: pageNumber, serachVal: (search && search !=='') ? search: ""})
      dispatch({ type: actionTypes.PAGE_LOADER_PENDING });
      response.then((res) => {
         dispatch({ type: actionTypes.PAGE_LOADER_SUCCESS });
         if (res.status === 1) {
            dispatch({ type: actionTypes.USERS_LIST, payload: res.response, count: res.total });
         } else if (res.status === 2) {
            dispatch({ type: actionTypes.USERS_LIST, payload: [], count: 0 });
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Listed.', alignment: 'centre' },
            });
         }
      });
   };
};
export const deletedCompanyUserLists = (skip, limit, pageNumber, search) => {
   return (dispatch) => {
      let response = fetchData({
         url: '/company/users/deleted/list',
         method: 'POST',
         data: { limit: limit, skip: skip, search: search, companyId: sessionStorage.getItem('userId') },
      });
      //dispatch({type: actionTypes.SET_TABLE_ATTRIBUTES, page_no: pageNumber, serachVal: (search && search !=='') ? search: ""})
      dispatch({ type: actionTypes.PAGE_LOADER_PENDING });
      response.then((res) => {
         dispatch({ type: actionTypes.PAGE_LOADER_SUCCESS });
         if (res.status === 1) {
            dispatch({ type: actionTypes.USERS_LIST, payload: res.response, count: res.total });
         } else if (res.status === 2) {
            dispatch({ type: actionTypes.USERS_LIST, payload: [], count: 0 });
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Listed.', alignment: 'centre' },
            });
         }
      });
   };
};

export const uploadLogo = (data, key, type) => {
   var formData = new FormData();
   if (key === 'signature') {
      formData.append('signature', data);
   }
   if (key === 'companyLogo') {
      formData.append('companyLogo', data);
   }
   return (dispatch) => {
      let response = fetchData({ url: '/admin/users/image/upload', method: 'POST', data: formData });
      response.then((res) => {
         if (res.status === 1) {
            if (type === 'Edit' || type === 'Add') {
               dispatch({
                  type: type === 'Add' ? actionTypes.ADD_VIEW_USER : actionTypes.EDIT_VIEW_USER,
                  payload: res.message,
               });
            }
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Successfully Uploaded.', alignment: 'centre' },
            });
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Uploaded.', alignment: 'centre' },
            });
         }
      });
   };
};

export const addUser = (userData, props) => {
   let formData = {
      firstname: userData.firstname ? userData.firstname : '',
      lastname: userData.lastname ? userData.lastname : '',
      email: userData.email ? userData.email : '',
      password: userData.password ? userData.password : '',
      phone: userData.phone ? userData.phone : '',
      companyLogo: userData.companyLogo ? userData.companyLogo : '',
      companyId: sessionStorage.getItem('userId'),
      permission: userData && userData.permission && userData.permission.length > 0 ? JSON.stringify(userData.permission) : JSON.stringify([]),
      folders: userData && userData.folders && userData.folders.length > 0 ? JSON.stringify(userData.folders) : JSON.stringify([]),
      // user_roles: userData && userData.user_roles && String(userData.user_roles).length > 0 && String(userData.user_roles) !== String(undefined) && String(userData.user_roles) !== String(null) ? userData.user_roles : '',
   };
   return (dispatch) => {
      let response = fetchData({ url: '/company/users/add', method: 'POST', data: formData });
      dispatch({ type: actionTypes.BUTTON_PENDING });
      response.then((res) => {
         dispatch({ type: actionTypes.BUTTON_SUCCESS });
         if (res.status === 1) {
            dispatch({ type: actionTypes.CLEAR_ADD_VIEW_USER, payload: {} });
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Successfully Added.', alignment: 'centre' },
            });
            props.history.push('/users');
         } else if (res.status === 0) {
            if (typeof res.response === 'object') {
               dispatch({
                  type: actionTypes.BOTTOM_T_W_AL,
                  payload: { show_hide: true, text: 'Something Went Wrong.', alignment: 'centre' },
               });
            } else {
               dispatch({
                  type: actionTypes.BOTTOM_T_W_AL,
                  payload: { show_hide: true, text: res.response, alignment: 'centre' },
               });
            }
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Added.', alignment: 'centre' },
            });
         }
      });
   };
};

export const editView = (companyId) => {
   return (dispatch) => {
      let response = fetchData({ url: '/company/users/edit', method: 'POST', data: { userId: companyId } });
      response.then((res) => {
         if (res.status === 1) {
            dispatch({
               type: actionTypes.EDIT_VIEW_USER,
               payload: res.response,
            });
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: res.response, alignment: 'centre' },
            });
         }
      });
   };
};

export const editUser = (userData, props) => {
   let formData = {
      firstname: userData.firstname ? userData.firstname : '',
      lastname: userData.lastname ? userData.lastname : '',
      email: userData.email ? userData.email : '',
      phone: userData.phone ? userData.phone : '',
      companyLogo: userData.companyLogo ? userData.companyLogo : '',
      _id: userData._id,
      permission: userData && userData.permission && userData.permission.length > 0 ? JSON.stringify(userData.permission) : JSON.stringify([]),
      folders: userData && userData.folders && userData.folders.length > 0 ? JSON.stringify(userData.folders) : JSON.stringify([]),
      // user_roles: userData && userData.user_roles && String(userData.user_roles).length > 0 && String(userData.user_roles) !== String(undefined) && String(userData.user_roles) !== String(null) ? userData.user_roles : '',
   };
   if (typeof userData.password !== 'undefined' && userData.password !== '') {
      formData.password = userData.password;
   }
   return (dispatch) => {
      let response = fetchData({ url: '/company/users/update', method: 'POST', data: formData });
      dispatch({ type: actionTypes.BUTTON_PENDING });
      response.then((res) => {
         dispatch({ type: actionTypes.BUTTON_SUCCESS });
         if (res.status === 1) {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Successfully Updated.', alignment: 'centre' },
            });
            props.history.push('/users');
         } else if (res.status === 0) {
            if (typeof res.response === 'object') {
               dispatch({
                  type: actionTypes.BOTTOM_T_W_AL,
                  payload: { show_hide: true, text: 'Something Went Wrong.', alignment: 'centre' },
               });
            } else {
               dispatch({
                  type: actionTypes.BOTTOM_T_W_AL,
                  payload: { show_hide: true, text: res.response, alignment: 'centre' },
               });
            }
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Updated.', alignment: 'centre' },
            });
         }
      });
   };
};

export const deleteUser = (companyId, props) => {
   return (dispatch) => {
      let response = fetchData({ url: '/company/users/delete', method: 'POST', data: { delId: companyId } });
      response.then((res) => {
         if (res.status === 1) {
            dispatch({
               type: actionTypes.USER_DELETE_MODAL,
               companyId: '',
            });
            dispatch({
               type: actionTypes.DELETE_MODAL_VIEW,
               payload: {},
            });
            dispatch({ type: actionTypes.UPADTE_USER_LIST, userId: companyId });
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'SuccessFully Deleted.', alignment: 'centre' },
            });
            // props.history.push('/company/users');
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Deleted.', alignment: 'centre' },
            });
         }
      });
   };
};
export const deleteUserPermanent = (companyId) => {
   return (dispatch) => {
      let response = fetchData({ url: `/company/users/permanent/delete?delId=${companyId}`, method: 'DELETE' });
      response.then((res) => {
         if (res.status === 1) {
            dispatch({
               type: actionTypes.USER_DELETE_MODAL,
               companyId: '',
            });
            dispatch({
               type: actionTypes.DELETE_MODAL_VIEW,
               payload: {},
            });
            dispatch({ type: actionTypes.UPADTE_USER_LIST, userId: companyId });
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'SuccessFully Deleted.', alignment: 'centre' },
            });
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Deleted.', alignment: 'centre' },
            });
         }
      });
   };
};
export const restoreUser = (id) => {
   return (dispatch) => {
      let response = fetchData({ url: `/company/users/restore?userId=${id}`, mrthod: 'GET' });
      response.then((res) => {
         if (res.status === 1) {
            dispatch({
               type: actionTypes.RESTORE_MODAL_VIEW,
               payload: {},
            });
            dispatch({ type: actionTypes.UPADTE_USER_LIST, userId: id });
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'User Restored SuccessFully.', alignment: 'centre' },
            });
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Not Restored.', alignment: 'centre' },
            });
         }
      });
   };
};

export const GetAdminAddedRoles = () => {
   return (dispatch) => {
      let response = fetchData({ url: '/site/get/admin/roles', method: 'POST', data: {} });
      response
         .then((res) => {
            if (res && +res.status === 1) {
               dispatch({
                  type: actionTypes.ADMIN_ADDED_ROLES,
                  payload: res.response,
               });
            } else {
               dispatch({
                  type: actionTypes.ADMIN_ADDED_ROLES,
                  payload: [],
               });
            }
         })
         .catch((err) => {
            console.log(`catch in export const GetAdminAddedRoles ${err}`);
         });
   };
};

export const CLEAR_GetAdminAddedRoles = () => {
   return { type: actionTypes.ADMIN_ADDED_ROLES, payload: [] };
};

export const Add_permission = (item) => {
   return {
      type: actionTypes.ADD_ROLES_DATA,
      payload: item,
   };
};

export const Edit_permission = (item) => {
   return {
      type: actionTypes.EDIT_ROLES_DATA,
      payload: item,
   };
};

export const Get_perm = () => {
   return {
      type: actionTypes.SUBADMIN_ROLES_LIST,
      payload: [],
   };
};

export const ClEAR_USERS_ACTIVITY = () => {
   return {
      type: actionTypes.USERS_ACTIVITY_LIST,
      payload: [],
   };
};

export const GET_USERS_ACTIVITY = (_id) => {
   return (dispatch) => {
      let response = fetchData({ url: '/site/users/activity/list', method: 'POST', data: { _id } });
      response
         .then((res) => {
            if (res && +res.status === 1) {
               dispatch({
                  type: actionTypes.USERS_ACTIVITY_LIST,
                  payload: [...res.response],
               });
            } else {
               dispatch({
                  type: actionTypes.USERS_ACTIVITY_LIST,
                  payload: [],
               });
            }
         })
         .catch((err) => {
            dispatch({
               type: actionTypes.USERS_ACTIVITY_LIST,
               payload: [],
            });
         });
   };
};

export const getHistory = (userId, skip, limit, date, type) => {
   return async (dispatch) => {
      const res = await fetchData({ url: '/user/history', method: 'POST', data: { userId, skip, limit, date, type } });
      if (res.status === 1) {
         dispatch({ type: actionTypes.USER_HISTORY_LIST, payload: res.response, total: res.total });
      } else {
         dispatch({ type: actionTypes.BOTTOM_T_W_AL, payload: { show_hide: true, text: res.response, alignment: 'centre' } });
      }
   };
};

export const historyDateFunc = (data) => {
   return {
      type: actionTypes.USER_HISTORY_DATE,
      payload: data,
   };
};

export const historyTypeFunc = (data) => {
   return {
      type: actionTypes.USER_HISTORY_TYPE,
      payload: data,
   };
};
export const getSelectedUsers = (data) => {
   return {
      type: actionTypes.SELECTED_USERS,
      payload: data ? data : [],
   };
};

export const addUserGroupData = (data) => {
   return {
      type: actionTypes.ADD_USERGROUP_DATA,
      payload: data ? data : {},
   };
};
export const editUserGroupData = (data) => {
   return {
      type: actionTypes.EDIT_USERGROUP_DATA,
      payload: data ? data : {},
   };
};

export const getUsers = () => {
   return async (dispatch) => {
      let userId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '';
      if (userId && userId !== undefined) {
         let result = await fetchData({ url: `/company/employees/all?id=${userId}`, method: 'GET' });
         if (result && result.status === 1) {
            dispatch({
               type: actionTypes.GET_ALL_USERS,
               payload: result.response && result.response.length > 0 ? result.response : [],
            });
         } else {
            dispatch({
               type: actionTypes.GET_ALL_USERS,
               payload: [],
            });
         }
      }
   };
};
export const clearSearchVal = () => {
   return {
      type: actionTypes.CLEAR_SEARCH_VALUE,
   };
};
export const setSearchedValue = (data) => {
   return {
      type: actionTypes.SET_SEARCHED_VALUE,
      payload: data,
   };
};
export const getGroupList = (skip, limit, activePage, search) => {
   return async (dispatch) => {
      let formData = {};
      formData['skip'] = skip ? skip : 0;
      formData['limit'] = limit ? limit : 25;
      formData['search'] = search && search !== undefined && search !== null ? search : '';
      let userId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '';
      if (userId && userId !== undefined) {
         formData['userId'] = userId ? userId : '';
         let result = await fetchData({ url: `/company/group/list`, method: 'POST', data: formData });
         if (result && result.status === 1) {
            dispatch({
               type: actionTypes.USER_GROUPS_LIST,
               payload: result.response && result.response.length > 0 ? result.response : [],
               total: result.total ? result.total : 0,
            });
            dispatch({
               type: actionTypes.USER_TABLE_ATTRIBUTES,
               payload: {
                  skip: skip,
                  activePage: activePage,
                  searchValue: search ? search : '',
               },
            });
         } else {
            dispatch({
               type: actionTypes.USER_GROUPS_LIST,
               payload: [],
               total: 0,
            });
            dispatch({
               type: actionTypes.USER_TABLE_ATTRIBUTES,
               payload: {
                  skip: 0,
                  acttivePage: 1,
                  searchValue: '',
               },
            });
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: result.response, alignment: 'centre' },
            });
         }
      }
   };
};
export const createGroup = (data, props) => {
   return async (dispatch) => {
      let userId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '';
      if (userId && userId !== undefined) {
         data['userId'] = userId ? userId : '';
         let result = await fetchData({ url: `/company/group/create`, method: 'POST', data: data });
         if (result && result.status === 1) {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: result.response, alignment: 'centre' },
            });
            dispatch({
               type: actionTypes.ADD_USERGROUP_DATA,
               payload: {},
            });
            dispatch({
               type: actionTypes.SELECTED_USERS,
               payload: [],
            });
            props.history.push('/groups');
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: result.response, alignment: 'centre' },
            });
         }
      }
   };
};
export const getGroupById = (id) => {
   let data = {};
   return async (dispatch) => {
      let userId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '';
      if (userId && userId !== undefined) {
         data['userId'] = userId ? userId : '';
         data['groupId'] = id ? id : '';
         if (data['groupId'] && data['groupId'] !== undefined && data['groupId'] !== '') {
            let result = await fetchData({ url: `/company/group/edit`, method: 'GET', params: data });
            if (result && result.status === 1) {
               dispatch({
                  type: actionTypes.EDIT_USERGROUP_DATA,
                  payload: result.response ? result.response : {},
               });
            } else {
               dispatch({
                  type: actionTypes.BOTTOM_T_W_AL,
                  payload: { show_hide: true, text: result.response, alignment: 'centre' },
               });
            }
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: 'Group id not found', alignment: 'centre' },
            });
         }
      }
   };
};
export const updateGroup = (data, props) => {
   return async (dispatch) => {
      let userId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '';
      if (userId && userId !== undefined) {
         data['userId'] = userId ? userId : '';
         let result = await fetchData({ url: `/company/group/update`, method: 'POST', data: data });
         if (result && result.status === 1) {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: result.response, alignment: 'centre' },
            });
            dispatch({
               type: actionTypes.SELECTED_USERS,
               payload: [],
            });
            props.history.push('/groups');
         } else {
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: result.response, alignment: 'centre' },
            });
         }
      }
   };
};
export const deleteGroup = (groupId) => {
   return async (dispatch) => {
      let userId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : '';
      let result = await fetchData({ url: `/company/group/delete?groupId=${groupId}`, method: 'DELETE' });
      if (result.status === 1) {
         dispatch({
            type: actionTypes.DELETE_MODAL_VIEW,
            payload: {},
         });
         dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: 'SuccessFully Deleted.', alignment: 'centre' },
         });
         let result = await fetchData({ url: `/company/group/list`, method: 'POST', data: { skip: 0, limit: 25, userId: userId } });
         if (result && result.status === 1) {
            dispatch({
               type: actionTypes.USER_GROUPS_LIST,
               payload: result.response && result.response.length > 0 ? result.response : [],
               total: result.total ? result.total : 0,
            });
         } else {
            dispatch({
               type: actionTypes.USER_GROUPS_LIST,
               payload: [],
               total: 0,
            });
            dispatch({
               type: actionTypes.BOTTOM_T_W_AL,
               payload: { show_hide: true, text: result.response, alignment: 'centre' },
            });
         }
      } else {
         dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: 'Not Deleted.', alignment: 'centre' },
         });
      }
   };
};
export const getClickedId = (id) => {
   return {
      type: actionTypes.SET_CLICKED_ID,
      payload: id ? id : '',
   };
};

export const resetTableAttribute = () => {
   return {
      type: actionTypes.SET_TABLE_ATTRIBUTES,
      page_no: 1,
      serachVal: '',
      skip: 0,
   };
};

export const getMainFolderlist = () => {
   let userId = sessionStorage.getItem('userId');
   return async (dispatch) => {
      let result = await fetchData({ url: `/user/mainparent/folder/list`, method: 'POST', data: { userId } });
      if (result.status === 1) {
         dispatch({
            type: actionTypes.MAIN_PARENT_FOLDER_LIST,
            payload: result.response.mainfolderList && result.response.mainfolderList !== null ? result.response.mainfolderList : {},
         });
         dispatch({
            type: actionTypes.SUB_FOLDER_LIST,
            payload: result.response.subfolderList && result.response.subfolderList !== null ? result.response.subfolderList : {},
         });
      } else if (result.status === 2) {
         dispatch({
            type: actionTypes.MAIN_PARENT_FOLDER_LIST,
            payload: {},
         });
      } else {
         dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: result.response, alignment: 'centre' },
         });
      }
   };
};

export const addBranch = (data) => {
   return async (dispatch) => {
      let result = await fetchData({ url: `/company/branch/add`, method: 'POST', data: data });
      if (result && result.status === 1) {
         dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: result.response, alignment: 'centre' },
         });
         dispatch(getBranch());
      } else {
                 dispatch(getBranch());

         dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: result.response, alignment: 'centre' },
         });
      }
   };
};
export const getBranch = () => {
   return async (dispatch) => {
      let result = await fetchData({ url: `/company/branches/get`, method: 'GET' });
      if (result && result.status === 1) {
        console.log("branches",result.response);
         dispatch({
            type: actionTypes.BRANCH_LIST,
            payload: result.response && result.response.length > 0 ? result.response : [],
         });
      }else {
         dispatch({
            type: actionTypes.BRANCH_LIST,
            payload: [],
         });
      }
   };
};
export const deleteBranch = (data) => {
   return async (dispatch) => {
      let result = await fetchData({ url: `/company/branches/delete`, method: 'POST', data: data });
      if (result && result.status === 1) {
        dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: result.response, alignment: 'centre' },
         });
      } else {
        dispatch({
            type: actionTypes.BOTTOM_T_W_AL,
            payload: { show_hide: true, text: result.response, alignment: 'centre' },
         });
      }
   };
};
